import axios from "axios";
import {
  AxiosInstance,
  CreateAxiosDefaults,
  InternalAxiosRequestConfig,
} from "axios";

/**
 * The base client that should be extended.
 *
 * Handles setting up the Axios instance and request interceptor.
 * Does not handle response interception as that should be client-specific.
 */
export abstract class BaseClient {
  protected _instance: AxiosInstance;

  constructor(config: CreateAxiosDefaults) {
    const instance = axios.create(config);

    instance.interceptors.request.use(this.request, (err) => err);

    this._instance = instance;
  }

  protected async request(
    config: InternalAxiosRequestConfig,
  ): Promise<InternalAxiosRequestConfig> {
    config.headers.Authorization = localStorage.getItem("token");
    return config;
  }
}
